import unescapedText from 'I18n/utils/unescapedText';
import { useMemo } from 'react';

interface ListingMetaDescriptionProps {
  tagline?: string;
  /** Whether the product is built by HubSpot (used as certification indicator) */
  certified?: boolean;
  productType?: string;
}

/**
 * Hook that formats listing page meta descriptions for SEO according to the requirements:
 *
 * Certified (builtByHubSpot): {Tagline} - HubSpot Certified {Product}
 * Not certified: {Tagline}
 */
export function useListingMetaDescription(
  props?: ListingMetaDescriptionProps
): string | undefined {
  return useMemo(() => {
    if (!props?.tagline) {
      return undefined;
    }

    const { tagline, certified = false, productType = 'APP' } = props;

    const productTypeName =
      productType === 'AGENT'
        ? unescapedText(
            'marketplaceStorefront.listingMetaDescription.productTypes.agent'
          )
        : unescapedText(
            'marketplaceStorefront.listingMetaDescription.productTypes.app'
          );

    if (certified) {
      return unescapedText(
        'marketplaceStorefront.listingMetaDescription.certified',
        {
          tagline,
          productType: productTypeName,
        }
      );
    } else {
      return unescapedText(
        'marketplaceStorefront.listingMetaDescription.notCertified',
        {
          tagline,
        }
      );
    }
  }, [props]);
}
